import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { getSidesOnDraftShopAsync } from "../../api/medal/drafts";
import styles from "./orderItemView.module.css";

const sidesName = {
  1: "Аверс",
  2: "Реверс",
  3: "Лента",
};

const SVG_PATH = "https://storage.yandexcloud.net/medals/editors/svg.html";

function openSvgExport(draftId, sideId, jwt) {
  const params = new URLSearchParams({
    draftId: String(draftId),
    sideId: String(sideId),
    token: jwt,
  });

  // Fragment не отправляется в Object Storage и не попадает в его access-логи.
  window.open(`${SVG_PATH}#${params.toString()}`, "_blank", "noopener,noreferrer");
}

export default function OrderItemView({ jwt, item }) {
  const [sides, setSides] = useState([1, 2, 3]);

  useEffect(() => {
    getSidesOnDraftShopAsync(item.itemId, jwt)
      .then(setSides)
      .catch(console.log);
  }, [item.itemId, jwt]);

  return (
    <div className={styles.item}>
      <div className={styles.header}>
        <div className={styles.itemTitle}>#{item.name}</div>
        <div className={styles.itemMeta}>ID: {item.itemId}</div>
      </div>

      <div className={styles.actions}>
        {sides.map((sideId) => (
          <Button
            key={sideId}
            className={styles.downloadButton}
            onClick={() => openSvgExport(item.itemId, sideId, jwt)}
          >
            {sidesName[sideId]}
          </Button>
        ))}
      </div>
    </div>
  );
}
